import { domHelpers } from '@approvalmax/utils';
import * as common from 'modules/common';
import { State } from 'modules/data';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useMount } from 'react-use';
import { api } from 'services/api';
import { notificationService } from 'services/notification';
import { routingService } from 'services/routing';

import { messages } from './useDownloadAuditReportCollectionData.messages';

const useDownloadAuditReportCollectionData = () => {
    const { companyId, collectionId } = useParams<{ companyId: string; collectionId: string }>();

    const company = useSelector((state: State) => common.selectors.company.findCompanyById(state, companyId));
    const user = useSelector(common.selectors.profile.findProfileUser);

    useMount(() => {
        if (company && user && (company.managers.includes(user.id) || company.auditors.includes(user.id))) {
            const url = api.requestReports.urls.getAuditReportsCollection(companyId, collectionId);

            domHelpers.downloadUrl(url);
        } else {
            notificationService.showErrorToast(messages.auditReportErrorAccessDenied);
        }

        routingService.replaceToDefaultPath();
    });
};

export default useDownloadAuditReportCollectionData;
